export default __webpack_public_path__ + "static/media/ic_access_time_48px.97464942.svg";